import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Col,
  Row,
  Container,
  Card,
  CardBody,
  Button,
  Table,
  Spinner,
} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"

import Spinners from "components/Common/Spinner"
import { useNavigate, useParams } from "react-router-dom"
import { get } from "helpers/api_helper"

const SurveyLineCampaignHistory = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  const [isLoading, setIsLoading] = useState(true)
  const [isExporting, setIsExporting] = useState(false)
  const [statsData, setStatsData] = useState(null)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const result = await get(
          process.env.REACT_APP_BACKEND_URL + "/v1/admin/line-campaign/" + id + "/stats"
        )
        if (result?.data) {
          setStatsData(result.data)
        }
      } catch (error) {
        console.error("Error fetching campaign stats:", error)
      }
      setIsLoading(false)
    }

    fetchStats()
  }, [id])

  const handleExportStats = async () => {
    try {
      setIsExporting(true)
      const result = await get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/admin/line-campaign/${id}/stats/export`,
        { responseType: "blob" }
      )

      if (!result) return

      const now = new Date()
      const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(
        now.getDate()
      ).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}${String(
        now.getMinutes()
      ).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`
      const fileName = `line_campaign_stats_${id}_${timestamp}.xlsx`

      const blob = result instanceof Blob ? result : new Blob([result])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Error exporting campaign stats:", error)
    } finally {
      setIsExporting(false)
    }
  }

  document.title = "Campaign History | " + process.env.REACT_APP_CMS_TITLE

  if (isLoading) {
    return <Spinners setLoading={setIsLoading} />
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs
          title={"Survey Line Campaign"}
          breadcrumbItems={[
            { title: "Survey Line Campaign", link: "survey-line-campaign" },
            { title: "Campaign History", link: `history/${id}` },
          ]}
        />

        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0" style={{ fontWeight: "600" }}>
            Campaign History
            {statsData?.campaign_name && (
              <span style={{ color: "#74788d", fontSize: "1rem", fontWeight: "400" }}>
                {" "} — {statsData.campaign_name}
              </span>
            )}
          </h4>
          <Button
            type="button"
            color="success"
            style={{ minWidth: "120px" }}
            onClick={handleExportStats}
            disabled={isExporting}
          >
            {isExporting ? (
              <Spinner size="sm" color="light" />
            ) : (
              <>
                <i className="bx bx-export me-1"></i>
                Export
              </>
            )}
          </Button>
        </div>

        {/* Statistics */}
        <Row>
          <Col>
            <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
              <div
                className="p-3"
                style={{
                  backgroundColor: "#E6F8F3",
                  color: "#1a5d3a",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                  borderTopLeftRadius: "8px",
                  borderTopRightRadius: "8px",
                }}
              >
                Statistics
              </div>
              <CardBody>
                <div className="table-responsive">
                  <Table className="table table-bordered table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th style={{ textAlign: "center" }}>Total</th>
                        <th style={{ textAlign: "center" }}>Passed</th>
                        <th style={{ textAlign: "center" }}>Failed</th>
                        <th style={{ textAlign: "center" }}>Unfinished</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>{(statsData?.total ?? 0).toLocaleString()}</td>
                        <td style={{ textAlign: "center" }}>{(statsData?.passed ?? 0).toLocaleString()}</td>
                        <td style={{ textAlign: "center" }}>{(statsData?.failed ?? 0).toLocaleString()}</td>
                        <td style={{ textAlign: "center" }}>{(statsData?.unfinished ?? 0).toLocaleString()}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <Button
              type="button"
              outline
              color="secondary"
              style={{
                minWidth: "120px",
                backgroundColor: "#fff",
                borderColor: "#ced4da",
                color: "#495057",
              }}
              onClick={() => navigate("/survey-line-campaign")}
            >
              <i className="bx bx-arrow-back me-1"></i>
              Back
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

SurveyLineCampaignHistory.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(SurveyLineCampaignHistory)
